import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { map, catchError, tap, first, mergeMap } from 'rxjs/operators';


import { AppConfig } from '@solar/app.config';
import { ErrorcontrolService } from 'basecomponents';
import { Company } from 'solar-bo';
import { AuthenticationServiceAbs } from 'baseauth';
import { User } from 'solar-bo';
import { appcontrols } from 'solar-bo';


/* , useFactory: (http: HttpClient) =>
new AuthenticationService(http),
deps: [HttpClient] */

@Injectable({
    providedIn: 'root'
})
export class AuthenticationService implements AuthenticationServiceAbs {
    public currentUserSubject: BehaviorSubject<User>;
    private currentUser: Observable<User>;

    constructor(
        public http: HttpClient) {
        console.log("AuthenticationService initiated");    
        this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(localStorage.getItem('geo-currentUser')));
        this.currentUser = this.currentUserSubject.asObservable();
    }

    public get currentUserValue(): User {
        let user = this.currentUserSubject.getValue();
        //console.log("currentUserValue:::",user);
        return user;
    }

    login(username, password) {
        const url = AppConfig.API_ENDPOINT;
        const headeruserpws = username + ":" + password;
        const reqHeader: HttpHeaders = new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': 'Basic ' + btoa(headeruserpws)
        });
        return this.f1(url, username, password, reqHeader);
        //return this.f2(url,username,password,reqHeader);    
    }

    f1(url, username, password, reqHeader) {

        let resp = this.http.post<any>(`${url}/auth`, { 'user': username, 'password': password }, { headers: reqHeader })
            .pipe(
                map(respdata => {
                    let userObj: User = this.configUser(respdata);
                    this.currentUserSubject.next(userObj);
                    return userObj;
                }),
                catchError(error =>
                    this.userAuthenticationhandleerror(error)
                ));

        return resp.pipe(mergeMap(user => this.CompanyGetById(user)));
    }

    private configUser(respdata) {
        // store user details and jwt token in local storage to keep user logged in between page refreshes
        let userObj: User = User.configObject(respdata,appcontrols);
        if (respdata["app_configuration"]!=null){
            let cfg=respdata["app_configuration"];
            AppConfig.gis_configuration= cfg.GIS_SERVER_CONFIG;
            AppConfig.saveConfiguration();
        }
        
        //userObj.token=respdata.token;
        //console.log("auth response", respdata.user);
        //console.log("auth response token object", respdata.token);

        this.saveToLocalStorage(userObj);
        //return this.CompanyGetById(userObj);
        return userObj;
    }

    private saveToLocalStorage(userObj: User) {
        let tk = userObj.token;
        localStorage.setItem('geo-curtk', tk);
        localStorage.setItem('geo-currentUser', JSON.stringify(userObj));
    }

    private userAuthenticationhandleerror<T>(error): Observable<T> {
        if (error instanceof HttpErrorResponse) {
            switch (error.status) {
                case 401:
                    return throwError("Sorry, your credentials are not valid.");
                default:
                    return throwError(ErrorcontrolService.basichandleError("", error).text);

            }
        }
        return throwError(error || 'GeoAI server error');
    }

    logout() {
        // remove user from local storage and set current user to null
        
        localStorage.removeItem('geo-curtk');
        localStorage.removeItem('geo-currentUser');
        localStorage.removeItem('sites');
        localStorage.removeItem('supervisions');
        localStorage.removeItem('esolar-config');
        this.currentUserSubject.next(null);  
        console.log("Logout succesfull");     
    }


    CompanyGetById(userObj: any) {
        const urlb = AppConfig.API_ENDPOINT;
        const url = `${urlb}/companies/${userObj.company.id}`;
        let res1 = this.http.get<Company>(url, AppConfig.httpOptions).pipe(
            map(respdata => {
                userObj.company = respdata;
                this.saveToLocalStorage(userObj);
                this.currentUserSubject.next(userObj);
                return userObj;
            }),
            catchError(error =>
                this.userAuthenticationhandleerror<any>(error)
            ));
        return res1;
    }

    private userSaveCompany(res, userObj) {
        console.log(res);
        userObj.company = res,
            localStorage.setItem('geo-currentUser', JSON.stringify(userObj));
        this.currentUserSubject.next(userObj);
    }

}
